export default {
  multiplePoliciesFailedTitle: {
    id: 'policies_and_eligible_insurances_multiple_policies_failed_title',
    defaultMessage: '{failedPoliciesNumber} policies issues',
  },
  multiplePoliciesFailedDescription: {
    id: 'policies_and_eligible_insurances_multiple_policies_failed_description',
    defaultMessage:
      'Payments for {failedPoliciesNumber} subscriptions didn’t go through. Update your payment method to keep your devices protected:',
  },
  updatePaymentMethodDescription: {
    id: 'policies_and_eligible_insurances_update_payment_method_description',
    defaultMessage:
      'Protection Plan payment didn’t go through. Update your payment method to keep your device protected.',
  },
  updatePaymentMethodButton: {
    id: 'policies_and_eligible_insurances_update_payment_method_button',
    defaultMessage: 'Update payment method',
  },
}
